import { JobStatus } from '../enum/job';
import { request } from './request';

// 文件对象
export interface JobFileJo {
  name: string;
  s3key: string;
  url: string;
}

// 职位基本信息
export interface JobInfoDTO {
  id?: number;
  enterpriseId?: number;
  projectId?: number;
  title?: string;
  jobType?: number;
  residenceType?: number;
  status?: JobStatus;
  appOpen?: number;
  publishTime?: string;
  auditTime?: string;
  closeTime?: string;
  auditFailedReason?: string;
  appDisplayImages?: JobFileJo[];
  otherDocuments?: JobFileJo[];
  createBy?: number;
  createTime?: string;
  updateTime?: string;
  outOpen?: number;
}

// 招聘细节
export interface JobRecruitmentDetailDTO {
  id?: number;
  jobId?: number;
  positionType?: number;
  positionTypeNote?: string;
  recruitGraduateType?: string;
  jobIndustry?: number;
  hasJobTransfer?: number;
  jobTransferNote?: string;
  headcount?: number;
  isUrgent?: number;
  employmentForm?: number;
  hasEmploymentTerm?: number;
  employmentTermYears?: number;
  hasProbation?: number;
  probationMonths?: number;
  jobDescription?: string;
  careerPath?: string;
  workplaceAtmosphere?: string;
  recruitmentProcessId?: number;
  recruitmentDocsId?: number;
}

// 职位要求
export interface JobRequirementsDTO {
  id?: number;
  jobId?: number;
  japaneseLevelId?: number;
  hasCertificationReq?: number;
  certificationRequirement?: string;
  requiredExperience?: string;
  requirementNote?: string;
  extraPointColumn?: string;
}

// 工作时间
export interface JobWorkTimeDTO {
  id?: number;
  jobId?: number;
  affiliationId?: number;
  affiliationNote?: string;
  nearestStation?: string;
  workingHours?: string[];
  workingHoursNote?: string;
  stipulatedWorkTime?: number;
  stipulatedWorkTimeType?: string;
  stipulatedWorkTimeStr?: string;
  hasShifts?: number;
  shiftNote?: string;
  hasFlextime?: number;
  flextimeNote?: string;
  weeklyOffType?: number;
  weeklyOffOtherNote?: string;
  annualHolidays?: number;
  paidHolidaysRange?: number[];
  paidHolidaysNote?: string;
  paidHolidaysStr?: string;
  otherLeaves?: string;
  affiliationName?: string;
  affiliationComposition?: string;
  affiliationAddress?: string;
}

// 薪酬福利
export interface JobCompensationDTO {
  id?: number;
  jobId?: number;
  monthlyTotalType?: number;
  monthlyTotal?: number[];
  payMode?: string;
  baseSalaryType?: number;
  baseSalary?: number[];
  baseSalaryTimeType?: string;
  baseSalaryStr?: string;
  baseSalaryNote?: string;
  hasBonus?: number;
  bonusNote?: string;
  hasTransportAllowance?: number;
  transportAllowanceNote?: string;
  hasOvertimePay?: number;
  overtimePayNote?: string;
  hasNightShiftAllowance?: number;
  nightShiftNote?: string;
  otherAllowances?: string;
  probationPayType?: number;
  probationPay?: number[];
  probationPayTimeType?: string;
  probationPayStr?: string;
  probationPayNote?: string;
  hasSalaryIncrease?: number;
  salaryIncreaseNote?: string;
  socialInsuranceInfo?: number[];
  hasHousingSupport?: number;
  housingSupportNote?: string;
  hasVisaSupport?: number;
  visaSupportNote?: string;
  otherSupports?: string;
}

// 职位详情
export interface JobDetailDTO {
  jobId?: number;
  jobInfo: JobInfoDTO;
  jobRecruitmentDetail: JobRecruitmentDetailDTO;
  jobRequirements: JobRequirementsDTO;
  jobWorkTime: JobWorkTimeDTO;
  jobCompensation: JobCompensationDTO;
}

// 候选人列表请求参数
export interface JobCandidatePageRequest {
  pageNum?: number;
  pageSize?: number;
  sortColumn?: string;
  enterpriseId: number;
  projectId: number;
  jobId: number;
  stepId?: number;
  asc?: boolean;
}

// 面试步骤
export interface InterviewStep {
  id: number;
  interviewId: number;
  stepId: string;
  name: string;
  orderIndex: number;
  type: number;
  tplId: number;
  interviewerId: number;
  interviewType: number;
  interviewDuration: number;
  interviewStart: string;
  interviewEnd: string;
  interviewUrl: string;
  interviewLocation: string;
  interviewRemark: string;
  interviewSchedule: any[];
  evaluatedAt: string;
  evaluatedResult: number;
  evaluatedComments: string;
  joinAt: string;
  status: number;
  createBy: number;
  createTime: string;
  updateTime: string;
}

// 面试进度
export interface InterviewProgress {
  interviewId: number;
  candidateId: number;
  jobId: number;
  status: number;
  currentStep: InterviewStep;
  steps: InterviewStep[];
}

// 应聘记录
export interface ApplicationRecordVo {
  interviewId: number;
  jobId: number;
  candidateId: number;
  statusText: string;
  progress: InterviewProgress;
  createTime: string;
}

// 候选人摘要
export interface CandidateSummaryVo {
  candidateId: number;
  avatarUrl: string;
  name: string;
  nameKana: string;
  specialSkillTag: string;
  nationality: number;
  age: number;
  gender: string;
  highestEducationLevel: number;
  phone: string;
  email: string;
  residenceCardAddress: string;
  nearestStation: string;
  japaneseLevel: string;
  applicationChannel: number;
  aiSummary: string;
}

// 职位候选人记录
export interface JobCandidateRecord {
  applicationRecordVo: ApplicationRecordVo;
  candidateSummaryVo: CandidateSummaryVo;
}

// 分页响应
export interface IPageObject<T = any> {
  size: number;
  records: T[];
  current: number;
  total: number;
  pages: number;
}

// 更新记录
export interface JobUpdateRecord {
  id: number;
  userId: number;
  username: string;
  creator: string;
  operationType: string;
  requestUri: string;
  requestMethod: string;
  requestParams: string;
  operationNote: string;
  ipAddress: string;
  entityName: string;
  entityId: string;
  updateData: string;
  createTime: string;
}

// 更新记录分页请求参数
export interface JobUpdateRecordPageRequest {
  pageNum?: number;
  pageSize?: number;
  sortColumn?: string;
  jobId: number;
  asc?: boolean;
}

// 职位分页请求参数
export interface JobPageRequest {
  pageNum?: number;
  pageSize?: number;
  sortColumn?: string;
  enterpriseId?: number;
  projectId?: number;
  status?: string;
  jobIdList?: number[];
  positionTypeList?: number[];
  jobTypeList?: number[];
  employmentFormList?: number[];
  affiliationIdList?: number[];
  title?: string;
  createTimeStart: string | null;
  createTimeEnd: string | null;
  createByList?: number[];
  jobHeadhuntingOpenList?: number[];
  jobOutOpenList?: number[];
  asc?: boolean;
}

// 职位列表项
export interface JobListItem {
  jobId: number;
  positionType: number;
  residenceType: number;
  employmentForm: number;
  affiliationId: number;
  title: string;
  auditFailedReason: string;
  headcount: number;
  publishTime: string;
  auditTime: string;
  closeTime: string;
  createTime: string;
  createBy: number;
}

// 职位行业类型
export interface JobIndustryPosition {
  id: number;
  industryId: number;
  name: string;
}

// 职位类型
export interface JobType {
  id: number;
  name: string;
}

// 雇佣形式
export interface JobEmploymentForm {
  code: number;
  name: string;
}

// 所属关联
export interface JobAffiliation {
  id: number;
  affiliationName: string;
}

// 创建人角色信息
export interface RoleInfo {
  id: number;
  name: string;
  description: string;
}

// 职位创建人
export interface JobCreator {
  id: number;
  position: string;
  name: string;
  enterpriseId: number;
  email: string;
  status: number;
  roleInfo: RoleInfo;
}

// 全部选择器响应
export interface AllSelectorsResponse {
  jobIdList: number[];
  jobIndustryPositionList: JobIndustryPosition[];
  jobTypeList: JobType[];
  jobEmploymentFormList: JobEmploymentForm[];
  jobAffiliationList: JobAffiliation[];
  jobCreatorList: JobCreator[];
}

// 猎头开放职位面试统计项
export interface HeadhuntingOpenInterviewStatItem {
  jobId: number;
  headhuntingId: number;
  headhuntingName: string;
  resumeScreeningCount: number;
  interviewCount: number;
}

// 关闭职位面试统计项
export interface CloseInterviewStatItem {
  jobId: number;
  title: string;
  resumeScreeningCount: number;
  interviewCount: number;
}

/**
 * 创建职位
 * @param residenceType 在留资格类型
 * @param data 职位信息
 */
export function createJob(residenceType: number, data?: Partial<JobDetailDTO>) {
  return request<number>({
    url: `/ats-job/api/v1/job-info/${residenceType}`,
    method: 'POST',
    data
  });
}

/**
 * 获取职位详情
 * @param jobId 职位ID
 */
export function getJobDetail(jobId: number) {
  return request<JobDetailDTO>({
    url: `/ats-job/api/v1/job-info/${jobId}`,
    method: 'GET'
  });
}

/**
 * 更新职位
 * @param data 职位详情信息
 */
export function updateJob(data: JobDetailDTO) {
  return request<{jobId?: number}>({
    url: `/ats-job/api/v1/job-info`,
    method: 'PUT',
    data
  });
}
/**
 * 创建或更新职位
 * @param data 职位详情信息
 */
export function createOrUpdateJob(data: JobDetailDTO) {
  return request<{jobId?: number}>({
    url: `/ats-job/api/v1/job-info`,
    method: 'POST',
    data
  });
}
/**
 * 删除职位
 * @param jobId 职位ID
 */
export function deleteJob(jobId: number) {
  return request<boolean>({
    url: `/ats-job/api/v1/job-info/${jobId}`,
    method: 'DELETE'
  });
}

/**
 * 获取职位详情-投递候选人列表
 * @param data 查询参数
 */
export function getJobCandidatePage(data: JobCandidatePageRequest) {
  return request<IPageObject<JobCandidateRecord>>({
    url: `/ats-interview/api/v1/job-info/candidate-page`,
    method: 'POST',
    data
  });
}

/**
 * 关闭职位前检查
 * @param jobId 职位ID
 */
export function checkJobClose(jobId: number) {
  return request<boolean>({
    url: `/ats-job/api/v1/job-info/close-check/${jobId}`,
    method: 'GET'
  });
}

/**
 * 关闭职位
 * @param jobId 职位ID
 */
export function closeJob(jobId: number) {
  return request<boolean>({
    url: `/ats-job/api/v1/job-info/close/${jobId}`,
    method: 'PUT'
  });
}

/**
 * 删除职位前检查
 * @param jobId 职位ID
 */
export function checkJobDelete(jobId: number) {
  return request<boolean>({
    url: `/ats-job/api/v1/job-info/del-check/${jobId}`,
    method: 'GET'
  });
}

/**
 * 发布职位前检查
 * @param jobId 职位ID
 */
export function checkJobPublish(jobId: number) {
  return request<boolean>({
    url: `/ats-job/api/v1/job-info/publish-check/${jobId}`,
    method: 'GET'
  });
}

/**
 * 发布职位
 * @param jobId 职位ID
 */
export function publishJob(jobId: number) {
  return request<boolean>({
    url: `/ats-job/api/v1/job-info/publish/${jobId}`,
    method: 'PUT'
  });
}

/**
 * 获取职位更新记录列表
 * @param data 查询参数
 */
export function getJobUpdateRecordPage(data: JobUpdateRecordPageRequest) {
  return request<IPageObject<JobUpdateRecord>>({
    url: `/ats-job/api/v1/job-info/update-record/page`,
    method: 'POST',
    data
  });
}

/**
 * 获取职位分页列表
 * @param data 查询参数
 */
export function getJobPage(data: JobPageRequest) {
  return request<IPageObject<JobListItem>>({
    url: `/ats-job/api/v1/job-page`,
    method: 'POST',
    data
  });
}

/**
 * 获取所有选择器数据
 */
export function getAllSelectors() {
  return request<AllSelectorsResponse>({
    url: `/ats-job/api/v1/dim/all-seletors`,
    method: 'GET'
  });
}
/**
 * 批量关闭职位
 */
export function batchCloseJob(params: number[]) {
  return request<AllSelectorsResponse>({
    url: `/ats-job/api/v1/job-info/batch/close`,
    method: 'PUT',
    data: params
  });
}

/**
 * 批量关闭前检查 - 获取选考中的候选人数量
 * @param jobIds 职位ID数组
 */
export function checkJobCloseBatch(jobIds: number[]) {
  return request<number[]>({
    url: `/ats-job/api/v1/job-info/batch/close-check`,
    method: 'POST',
    data: jobIds
  });
}

/**
 * 获取猎头开放职位面试统计
 * @param params 查询参数
 */
export function getHeadhuntingOpenInterviewStat(params: { jobId: number; headhuntingCompanyIds: number[] }) {
  console.log('params', params)
  return request<HeadhuntingOpenInterviewStatItem[]>({
    url: `/ats-job/api/v1/job-info/headhunting-open/interview-stat`,
    method: 'GET',
    params,
    paramsSerializer: (params) => {
      const parts: string[] = [];
      Object.keys(params).forEach(key => {
        const value = params[key];
        if (Array.isArray(value)) {
          if (value.length === 0) {
            // 空数组也添加参数
            parts.push(`${key}=`);
          } else {
            value.forEach(v => parts.push(`${key}=${encodeURIComponent(v)}`));
          }
        } else {
          parts.push(`${key}=${encodeURIComponent(value)}`);
        }
      });
      return parts.join('&');
    }
  });
}

/**
 * 获取关闭职位面试统计
 * @param params 查询参数
 */
export function getCloseInterviewStat(params: { jobIds: number[] }) {
  return request<CloseInterviewStatItem[]>({
    url: `/ats-job/api/v1/job-info/close/interview-stat`,
    method: 'GET',
    params
  });
}

/**
 * 批量对外公开/不公开
 * @param jobIds 职位ID数组
 * @param open 是否公开(0/1)
 */
export function batchPublicOpen(data: { jobIds: number[]; open: 0 | 1 }) {
  return request<boolean>({
    url: `/ats-job/api/v1/job-info/batch/out-open`,
    method: 'PUT',
    data
  });
}

// 职位预览数据
export interface JobPreviewDTO {
  /* 职位id */
  id: number;

  /* 企业ID */
  enterpriseId: number;

  /* 企业名称 */
  enterpriseName: string;

  /* 职位标题 */
  title: string;

  /* 职位类型(1:特定技能,2:技人国,3:资格外活动) */
  jobType: number;

  /* 职位类型(1:特定技能,2:技人国,3:资格外活动) */
  jobTypeStr: string;

  /* 岗位类型 */
  positionType: number;

  /* 岗位类型 */
  positionTypeStr: string;

  /* 岗位类型说明 */
  positionTypeNote: string;

  /* 行业 */
  jobIndustry: number;

  /* 行业 */
  jobIndustryStr: string;

  /* 招聘对象类型(1:往届,2:应届) */
  recruitGraduateType: Record<string, unknown>[];

  /* 招聘对象类型(1:往届,2:应届) */
  recruitGraduateTypeStr: string;

  /* 是否有转岗(0:无,1:有) */
  hasJobTransfer: number;

  /* 转岗说明 */
  jobTransferNote: string;

  /* 是否急聘(0/1) */
  isUrgent: number;

  /* 雇佣形式(1:正式员工, 2:合同员工, 3:兼职) */
  employmentForm: number;

  /* 雇佣形式(1:正式员工, 2:合同员工, 3:兼职) */
  employmentFormStr: string;

  /* 是否有雇佣期限(0/1) */
  hasEmploymentTerm: number;

  /* 雇佣期限（年） */
  employmentTermYears: string;

  /* 是否有试用期(0/1) */
  hasProbation: number;

  /* 试用期（月） */
  probationMonths: string;

  /* 工作内容/职位描述 */
  jobDescription: string;

  /* 职业路径 */
  careerPath: string;

  /* 职场氛围（简述） */
  workplaceAtmosphere: string;

  /* 选考流程 */
  recruitmentProcessId: number;

  /* 选考流程名称 */
  interviewFlowName: string;
  interviewFlowStepStr: string;

  /* 选考流程说明 */
  interviewFlowDescription: string;

  /* 面试方式(1:线上, 2:线下) */
  interviewType: number;

  /* 面试方式(1:线上, 2:线下) */
  interviewTypeStr: string;

  /* 面试方式说明 */
  interviewTypeNote: string;

  /* 日语等级 */
  japaneseLevelId: number;

  /* 日语等级 */
  japaneseLevelStr: string;

  /* 是否有资格要求 */
  hasCertificationReq: number;

  /* 资格要求描述 */
  certificationRequirement: string;

  /* 必要条件 */
  requirementNote: string;

  /* 额外加分项 */
  extraPointColumn: string;

  /* 所需经验/人选画像 */
  requiredExperience: string;

  /* 所属先ID */
  affiliationId: number;

  /* 所属先名称 */
  affiliationName: string;

  /* 所属先补充说明 */
  affiliationNote: string;

  /* 所属先构成 */
  affiliationComposition: string;

  /* 工作地址 */
  formattedAddress: string;

  /* 最近车站 */
  nearestStation: string;

  /* 工作时间(例如 [18,26]) */
  workingHours: Record<string, unknown>[];

  /* 工作时间说明 */
  workingHoursNote: string;

  /* 规定劳动时间（数值） */
  stipulatedWorkTime: string;

  /* 规定劳动时间单位 */
  stipulatedWorkTimeType: string;

  /* 规定劳动时间单位 */
  stipulatedWorkTimeTypeStr: string;

  /* 有无轮班工作 */
  hasShifts: number;

  /* 轮班工作说明 */
  shiftNote: string;

  /* 有无弹性工作 */
  hasFlextime: number;

  /* 弹性工作说明 */
  flextimeNote: string;

  /* 周休类型(1:完全周休二日制, 2:周休二日制, 3:シフト制, 4:その他) */
  weeklyOffType: number;

  /* 周休类型(1:完全周休二日制, 2:周休二日制, 3:シフト制, 4:その他) */
  weeklyOffTypeStr: string;

  /* 周休类型为其他时补充说明 */
  weeklyOffOtherNote: string;

  /* 年度休息日（天） */
  annualHolidays: string;

  /* 带薪年假范围（例如 10-15天） */
  paidHolidaysRange: Record<string, unknown>[];

  /* 带薪年假说明 */
  paidHolidaysNote: string;

  /* 其他休假说明 */
  otherLeaves: string;

  /* 月总支付金额类型（1:范围, 2:固定值） */
  monthlyTotalType: number;

  /* 月总支付金额 */
  monthlyTotal: Record<string, unknown>[];

  /* 月总支付金额文本 */
  monthlyTotalStr: string;

  /* 月总支付金额说明（旧字段改用） */
  baseSalaryNote: string;

  /* 基本薪资类型（1:范围, 2:固定值） */
  baseSalaryType: number;

  /* 基本薪资 */
  baseSalary: Record<string, unknown>[];

  /* 基本薪资单位 */
  baseSalaryTimeType: string;

  /* 基本薪资文本 */
  baseSalaryStr: string;

  /* 薪酬模式 */
  payMode: string;

  /* 有无奖金 */
  hasBonus: number;

  /* 奖金说明 */
  bonusNote: string;

  /* 有无交通补贴 */
  hasTransportAllowance: number;

  /* 交通补贴说明 */
  transportAllowanceNote: string;

  /* 有无加班补贴 */
  hasOvertimePay: number;

  /* 加班补贴说明 */
  overtimePayNote: string;

  /* 有无夜班补贴 */
  hasNightShiftAllowance: number;

  /* 夜班补贴说明 */
  nightShiftNote: string;

  /* 有无境外人员旅游补贴 */
  hasOverseasWorkerTravelExpenseSupport: number;

  /* 境外人员旅游补贴说明 */
  overseasWorkerTravelExpenseSupportNote: string;

  /* 其他补贴说明 */
  otherAllowances: string;

  /* 试用期/研修期工资类型（1:范围, 2:固定值） */
  probationPayType: number;

  /* 试用期工资 */
  probationPay: Record<string, unknown>[];

  /* 试用期工资单位 */
  probationPayTimeType: string;

  /* 试用期/研修期工资文本 */
  probationPayStr: string;

  /* 试用期/研修期工资说明 */
  probationPayNote: string;

  /* 有无加薪 */
  hasSalaryIncrease: number;

  /* 加薪说明 */
  salaryIncreaseNote: string;

  /* 社会保险 */
  socialInsuranceInfo: Record<string, unknown>[];

  /* 社会保险文本 */
  socialInsuranceInfoStr: string;

  /* 有无住房支持 */
  hasHousingSupport: number;

  /* 住房支持说明 */
  housingSupportNote: string;

  /* 有无签证支持 */
  hasVisaSupport: number;

  /* 签证支持说明 */
  visaSupportNote: string;

  /* 其他支持 */
  otherSupports: string;
}

/**
 * 获取职位预览数据
 * @param jobId 职位ID
 */
export function getJobPreview(jobId: number) {
  return request<JobPreviewDTO>({
    url: `/ats-job/api/v1/job-info/preview/${jobId}`,
    method: 'GET'
  });
}

/**
 * 获取职位内部预览数据（企业内部预览使用）
 * @param jobId 职位ID
 */
export function getJobInsidePreview(jobId: number) {
  return request<JobPreviewDTO>({
    url: `/ats-job/api/v1/job-info/inside-preview/${jobId}`,
    method: 'GET'
  });
}

/**
 * 选考流程信息
 */
export interface InterviewFlowSelectorVo {
  /* 主键ID */
  id: number;
  /* 流程名称 */
  name: string;
  /* 流程描述 */
  description: string;
}

/**
 * 所属先信息
 */
export interface AffiliationSelectorVo {
  /* 所属先ID */
  id: number;
  /* 所属先名称 */
  affiliationName: string;
  /* 所属先构成 */
  affiliationComposition: string;
  /* 工作地址 */
  formattedAddress: string;
}

/**
 * 变更记录映射响应
 */
export interface ChangeRecordMappingResponse {
  /* 选考流程映射 */
  interviewFlowSelectorVoList: InterviewFlowSelectorVo[];
  /* 所属先信息映射 */
  affiliationSelectorVoList: AffiliationSelectorVo[];
}

/**
 * 获取变更记录映射数据（用于非企业端）
 * @param jobId 职位ID
 */
export function getChangeRecordMapping(jobId: number) {
  return request<ChangeRecordMappingResponse>({
    url: `/ats-job/api/v1/headhunting-job/change-records/mapping/${jobId}`,
    method: 'GET'
  });
}

/**
 * Tab计数响应
 */
export interface TabCountResponse {
  publishedCount: number;
  waitPublishCount: number;
  closedCount: number;
}

/**
 * 获取职位分页Tab计数
 * @param data 查询参数（与职位列表相同的筛选条件）
 */
export function getJobPageTabCount(data: JobPageRequest) {
  return request<TabCountResponse>({
    url: `/ats-job/api/v1/job-page/tab-cnt`,
    method: 'POST',
    data
  });
}
